<template>
	<BaseChart :option="finalOption" />
</template>

<script>
	export default {
		name: 'BarLineChart',
		props: {
			xData: {
				type: Array,
				default: () => [],
			},
			barData: {
				type: Array,
				default: () => [],
			},
			lineData: {
				type: Array,
				default: () => [],
			},
			option: Object,
		},

		computed: {
			baseOption() {
				return {
					grid: {
						bottom: '18%',
						right: '5%',
						top: '5%',
						left: '5%',
					},
					tooltip: {
						trigger: 'axis',
					},
					legend: {
						data: ['出租面积', '出租率'],
						bottom: '2%',
						itemWidth: 14,
						itemGap: 60,
					},
					xAxis: [
						{
							type: 'category',
							data: this.xData,
							splitLine: {
								show: true,
								lineStyle: { type: 'dashed' },
							},
						},
					],
					yAxis: [
						{
							type: 'value',
							axisLabel: {
								formatter: '{value} ㎡',
							},
							splitLine: {
								lineStyle: { type: 'dashed' },
							},
						},
						{
							type: 'value',
							axisLabel: {
								formatter: '{value} %',
							},
							splitLine: {
								lineStyle: { type: 'dashed' },
							},
						},
					],
					series: [
						{
							name: '出租面积',
							type: 'bar',
							color: '#4080FF',
							barWidth: '20%',
							tooltip: {
								valueFormatter: value => value + ' ㎡',
							},
							data: this.barData,
						},
						{
							name: '出租率',
							type: 'line',
							color: '#FB923C',
							yAxisIndex: 1,
							tooltip: {
								valueFormatter: value => value + ' %',
							},
							data: this.lineData,
						},
					],
				};
			},

			finalOption() {
				return this.merge(this.baseOption, this.option);
			},
		},

		methods: {
			merge(base, custom) {
				if (!custom) return base;

				return {
					...base,
					...custom,
					legend: {
						...base.legend,
						...(custom.legend || {}),
					},
					xAxis: base.xAxis.map((item, i) => ({
						...item,
						...(custom.xAxis && custom.xAxis[i]),
					})),
					yAxis: base.yAxis.map((item, i) => ({
						...item,
						...(custom.yAxis && custom.yAxis[i]),
					})),
					series: base.series.map((item, i) => ({
						...item,
						...(custom.series && custom.series[i]),
					})),
				};
			},
		},
	};
</script>
